export default __webpack_public_path__ + "static/image13-f74499d34d9182ed353af1fa05e5354d.jpg";